import * as Yup from 'yup';

const createReplyValidationSchema = Yup.object().shape({
  text: Yup.string().required('Please enter your reply')
});

export default createReplyValidationSchema;
